import { getCurrentLocale } from '@insight/toolkit-utils';

const locale = getCurrentLocale('insight_locale');

export const makeProductDetailURL = ({
  materialId,
  mfrName,
  manufacturerId,
  description,
}) => {
  if (!description || !mfrName) return '';
  const productDescription = description
    .replace(/[\.,-\/#!$%\"\'\^&\*;:{}=\-_`~()]/g, '')
    .trim()
    .replace(/ +(?= )/g, '')
    .replace(/\s/g, '-');
  return `/${locale}/shop/product/${encodeURIComponent(
    materialId
  )}/${encodeURIComponent(mfrName.toLowerCase())}/${encodeURIComponent(
    manufacturerId
  )}/${productDescription}/`;
};

export const productLandingPage = (mfrName) => {
  if (!mfrName) return '';
  return `/${locale}/search.html?qtype=all&q=${encodeURIComponent(
    mfrName.toLowerCase()
  )}&qsrc=k`;
};
